
import Transformer from './../transformer'
import purchaseOrders from './purchaseOrdersSupplies'
import objectToForm from '../../utils/objectToForm'
import assetURL from '../../utils/assetURL'
import moment from "moment";

export default class FreightTransformer extends Transformer {
  static fetch(freight) {
    let orders = purchaseOrders.fetchCollection(freight.orders)
    // let camp = freight.orders[0].camp.id
    let listOrders = {orders:[]}
    orders.forEach(element => {
      if(element.orderWarehouseName) {
        listOrders.orders.push(`${element.orderWarehouseName}: ${element.folio}`)
      } else {
        listOrders.orders.push(element.folio)
      }
    });
    let data = {
      id: freight.id,
      subtotalFreight: freight.subtotal,
      totalFreight: freight.total,
      provider: freight.provider.id,
      provider_name: freight.provider.name,
      orders: orders,
      listOrders: listOrders,
      addedDate: moment(freight.added_date).format("DD/MM/YYYY"),
      // warehouseName: freight.warehouse.length ? freight.warehouse[0].iwarehouse_name : "Sin almacén"
    }
    let freightFiles = {
      
    }
    if(freight.invoice_pdf){
      data.invoice_pdf = assetURL(freight.invoice_pdf)
      freightFiles.pdf = assetURL(freight.invoice_pdf)
    }
    if(freight.invoice_xml){
      data.invoice_xml = assetURL(freight.invoice_xml)
      freightFiles.xml = assetURL(freight.invoice_xml)
    }
    if(freight.invoice_number){
      freightFiles.invoice_number = freight.invoice_number
    }
    data.freightFiles = freightFiles
    return data
  }

  static send(freight) {
    let list_orders = []
    freight.orders.forEach(element => {
      list_orders.push(element.id)
    });
    var json_arr = JSON.stringify(list_orders);
    let data = {
      // warehouse: freight.warehouseId,
      total: freight.amount,
      subtotal: freight.subtotal,
      provider: freight.provider.id,
      orders: json_arr,
      is_active: true
    };
    if(freight.invoice_number)
      data.invoice_number = freight.invoice_number
    if(freight.invoice_pdf)
      data.invoice_pdf = freight.invoice_pdf;
    if(freight.invoice_xml)
      data.invoice_xml = freight.invoice_xml;

    return objectToForm(data)
  }
}


// WEBPACK FOOTER //
// ./src/transformers/purchase/freight.js